import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  LinearProgress,
} from '@material-ui/core';

import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';

//import { getInitials } from 'helpers';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const CompanyTable = props => {
  const { 
    className, 
    userRole,
    companies, 
    onSetSelectedCompanies,
    
    openProgress,
    page,
    rowsPerPage,
    item_total,
    onPageChange,
    onRowsPerPageChange,

    ...rest } = props;

  const classes = useStyles();

  const [selectedCompanies, setSelectedCompanies] = useState([]);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [page, setPage] = useState(0);

  const handleSelectAll = event => {

    let selectedCompanies;

    if (event.target.checked) {
      selectedCompanies = companies.map(company => company.id);
    } else {
      selectedCompanies = [];
    }

    setSelectedCompanies(selectedCompanies);
    onSetSelectedCompanies(selectedCompanies);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedCompanies.indexOf(id);
    let newSelectedCompanies = [];

    if (selectedIndex === -1) {
      newSelectedCompanies = newSelectedCompanies.concat(selectedCompanies, id);
    } else if (selectedIndex === 0) {
      newSelectedCompanies = newSelectedCompanies.concat(selectedCompanies.slice(1));
    } else if (selectedIndex === selectedCompanies.length - 1) {
      newSelectedCompanies = newSelectedCompanies.concat(selectedCompanies.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedCompanies = newSelectedCompanies.concat(
        selectedCompanies.slice(0, selectedIndex),
        selectedCompanies.slice(selectedIndex + 1)
      );
    }

    setSelectedCompanies(newSelectedCompanies);
    onSetSelectedCompanies(newSelectedCompanies);
  };

  useEffect(() => {
    //console.log('componentDidUpdate & companies changed');

    const newSelected = selectedCompanies.filter(id => {
      const findObj = companies.find(obj => obj.id == id);
      return findObj !== undefined && findObj !== null;
    });

    setSelectedCompanies(newSelected);
    onSetSelectedCompanies(newSelected);

  }, [companies]);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            {openProgress && <LinearProgress /> }
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={companies.length > 0 && selectedCompanies.length === companies.length}
                      color="primary"
                      indeterminate={
                        selectedCompanies.length > 0 &&
                        selectedCompanies.length < companies.length
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                  <TableCell>번호</TableCell>
                  <TableCell>택시회사명</TableCell>
                  <TableCell>계약상태</TableCell>
                  <TableCell>사업장구분</TableCell>
                  <TableCell>권역</TableCell>
                  <TableCell>그룹</TableCell>
                  <TableCell>디바이스장착수량</TableCell>
                  <TableCell>거래담당자</TableCell>
                  <TableCell>전화번호</TableCell>
                  <TableCell>등록일</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {companies.map((company, index) => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={company.id}
                    selected={selectedCompanies.indexOf(company.id) !== -1}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedCompanies.indexOf(company.id) !== -1}
                        color="primary"
                        onChange={event => handleSelectOne(event, company.id)}
                        value="true"
                        disabled={company.have_cars || company.contract === '종료'}
                      />
                    </TableCell>
                    <TableCell>{index}</TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        {/* <Avatar
                          className={classes.avatar}
                          src={category.avatarUrl}
                        >
                          {getInitials(category.name)}
                        </Avatar> */}
                        <Typography variant="body1">{company.name}</Typography>
                      </div>
                    </TableCell>
                    <TableCell>{company.contract}</TableCell>
                    <TableCell>{company.type}</TableCell>
                    <TableCell>{company.area}</TableCell>
                    <TableCell>{company.group}</TableCell>
                    <TableCell>{company.devices}</TableCell>
                    <TableCell>{company.manager}</TableCell>
                    <TableCell>{company.tel}</TableCell>
                    <TableCell>
                      {moment(company.reg_at).format('YYYY-MM-DD')}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          labelRowsPerPage=''
          component="div"
          count={item_total}
          onChangePage={onPageChange}
          onChangeRowsPerPage={onRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>
    </Card>
  );
};

CompanyTable.propTypes = {
  className: PropTypes.string,
  companies: PropTypes.array.isRequired
};

export default CompanyTable;
